import React, { useEffect, useRef } from "react";

const LUSAKA = [-15.4167, 28.2833];

// Interactive Leaflet map to drop/drag a pin for a listing location.
// Leaflet is loaded globally from index.html (window.L).
export function LocationPicker({ lat, lng, onChange }) {
  const elRef = useRef(null);
  const mapRef = useRef(null);
  const markerRef = useRef(null);

  useEffect(() => {
    const L = window.L;
    if (!L || !elRef.current || mapRef.current) return;

    const hasPin = lat != null && lng != null;
    const start = hasPin ? [lat, lng] : LUSAKA;
    const map = L.map(elRef.current).setView(start, hasPin ? 14 : 12);
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: "&copy; OpenStreetMap contributors",
      maxZoom: 19,
    }).addTo(map);

    // Self-contained SVG pin so we never depend on external marker PNGs
    // (unpkg images were failing to load and showed broken "?" boxes).
    const pinIcon = L.divIcon({
      className: "venda-pin",
      html:
        '<svg width="30" height="42" viewBox="0 0 30 42" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M15 0C6.7 0 0 6.7 0 15c0 10.5 15 27 15 27s15-16.5 15-27C30 6.7 23.3 0 15 0z" fill="#3F7D14" stroke="#ffffff" stroke-width="2"/>' +
        '<circle cx="15" cy="15" r="5.5" fill="#ffffff"/></svg>',
      iconSize: [30, 42],
      iconAnchor: [15, 42],
    });

    const marker = L.marker(start, { draggable: true, icon: pinIcon }).addTo(map);
    marker.on("dragend", () => {
      const p = marker.getLatLng();
      onChange(p.lat, p.lng);
    });
    map.on("click", (e) => {
      marker.setLatLng(e.latlng);
      onChange(e.latlng.lat, e.latlng.lng);
    });

    mapRef.current = map;
    markerRef.current = marker;
    setTimeout(() => map.invalidateSize(), 150);

    return () => {
      map.remove();
      mapRef.current = null;
      markerRef.current = null;
    };
  }, []);

  // Reflect external lat/lng changes (e.g. "Use my current location").
  useEffect(() => {
    if (mapRef.current && markerRef.current && lat != null && lng != null) {
      markerRef.current.setLatLng([lat, lng]);
      mapRef.current.setView([lat, lng], 15);
    }
  }, [lat, lng]);

  return (
    <div
      ref={elRef}
      data-testid="location-map"
      className="border border-border"
      style={{ height: 260, width: "100%", borderRadius: 12, overflow: "hidden", zIndex: 0 }}
    />
  );
}
